exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\n.section[data-v-55a74192] {\n  border-bottom: solid 2px black;\n  text-align: center;\n  margin: 10px 5% 10px 5%;\n  padding-bottom: 20px;\n}\n.section-description[data-v-55a74192] {\n  font-size: 18px;\n  margin-bottom: 5px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"id":"data-v-55a74192","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/ReschedulingPage/ReschedulingSenderCompletion.vue
// module id = 515
// module chunks = 0